import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios'

import config from '../config'

const apiClient = axios.create({
    baseURL: config.API.REST.api.endpoint
})

apiClient.interceptors.request.use(async (req) => {
    try {
        const session = await fetchAuthSession()
        const token = session.tokens?.idToken?.toString()
        if (token) {
            req.headers.Authorization = token
        }
    } catch (error) {
        console.error('Auth session error:', error)
    }
    return req
})

export default apiClient
